/**
 * @generated SignedSource<<a6e6b76827f916daa8420af01abc0e21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfoRating_seller$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"useSellerRating_seller">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfoRating_seller";
};
export type PdpRespSidebarSellerInfoRating_seller$key = {
  readonly " $data"?: PdpRespSidebarSellerInfoRating_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoRating_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoRating_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSellerRating_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "b30ade2ee2d9dee3969754afb012de6a";

export default node;
